import 'react-multi-carousel/lib/styles.css';
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Home.css';
import SolarCalculator from '../../Component/Header/SolarCalculator';
import Carousel from 'react-multi-carousel';
import { Helmet } from "react-helmet";

function importAll(r) {
  return r.keys().map((key) => ({
    name: key.replace('./', '').split('.')[0],
    logo: r(key),
  }));
}

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showCalculator, setShowCalculator] = useState(false);
  const overlayRef = useRef();

  useEffect(() => {
    if (location.state?.showCalculator) {
      setShowCalculator(true);
    }
  }, [location.state]);

  const closeCalculator = () => {
    setShowCalculator(false);
    navigate('/', { replace: true });
  };

  const clients = importAll(require.context('../../assets/Clients', false, /\.(png|jpe?g|svg)$/));
  const certificates = importAll(require.context('../../assets/Certificates', false, /\.(png|jpe?g|svg)$/));

  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 5, slidesToSlide: 2 },
    tablet: { breakpoint: { max: 1024, min: 600 }, items: 3, slidesToSlide: 2 },
    mobile: { breakpoint: { max: 600, min: 0 }, items: 2, slidesToSlide: 1 },
  };

  const general = [
    { logo: "/images/general/general_1.jpg", caption: "First One Year" },
    { logo: "/images/general/general_2.jpg", caption: "Free Services for One Year" },
    { logo: "/images/general/general_3.jpg", caption: "All Type of Payments" },
    { logo: "/images/general/general_4.jpg", caption: "Made in India" },
    { logo: "/images/general/general_5.jpg", caption: "0% EMI Available" },
  ];

  const products = [
    { id: 'solar-plant', name: 'Solar Power Plant', image: '/SolarPanels/Solar_plant.jpg' },
    { id: 'solar-heater', name: 'Solar Water Heater', image: '/SolarPanels/solar_water_heater.jpg' },
    { id: 'street-light', name: 'Solar Street Light', image: '/SolarPanels/Solar_street_light.jpg' },
    { id: 'ups-battery', name: 'UPS and Battery', image: '/SolarPanels/UPS_battery.jpg' },
    { id: 'cctv', name: 'CCTV Camera', image: '/SolarPanels/CCTV.jpg' },
    { id: 'ro-softener', name: 'RO and Softener', image: '/SolarPanels/RO_softner.jpg' },
    { id: 'lubricants', name: 'Lubricants', image: '/SolarPanels/Lubricants.jpg' },
    { id: 'services', name: 'Services', image: '/SolarPanels/Services.jpg' },
  ];

  return (
    <>
      <Helmet>
        <title>RP SMART ENERGY | Solar Energy Solutions in India</title>
        <meta name="description" content="RP Smart Solar provides rooftop solar installation..." />
        <meta name="keywords" content="solar panel, solar calculator, rooftop, RP Smart Solar" />
        <meta name="author" content="RP SMART ENERGY" />
        <link rel="canonical" href="https://www.rpsmartsolar.in/" />
      </Helmet>

      {showCalculator && (
        <div
          ref={overlayRef}
          className="solar-calculator-overlay"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100vh',
            background: 'rgba(0, 0, 0, 0.75)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '30px',
          }}
        >
          <div
            style={{
              background: 'white',
              padding: '30px',
              borderRadius: '10px',
              width: '90%',
              maxWidth: '800px',
              position: 'relative',
              boxShadow: '0 5px 25px rgba(0,0,0,0.3)',
              maxHeight: '90vh',
              overflowY: 'auto',
            }}
          >
            <button
              onClick={closeCalculator}
              style={{
                position: 'absolute',
                top: 10,
                right: 15,
                background: 'transparent',
                border: 'none',
                fontSize: '1.8rem',
                color: '#333',
                cursor: 'pointer',
              }}
            >
              &times;
            </button>
            <h3 className="text-center mb-4 text-primary">Calculator</h3>
            <SolarCalculator />
          </div>
        </div>
      )}

      <div className="home-container">
        <div className="home-overlay">
          
          <div className="container my-4">
            <h1 className="text-center mb-4" style={{ color: 'black' }}>Smart Solar Energy Solutions for Homes & Industries</h1>
            <h2 className="text-center mb-4">OUR PRODUCTS</h2>

            <div className="row">
              {products.map((product) => (
                <div className="col-6 col-md-3 col-12 mb-4" key={product.id}>
                  <Link to={`/product/${product.id}`} className="text-decoration-none">
                    <div className="product-card shadow-sm text-center p-2" style={{ borderRadius: 15 }}>
                      <img src={product.image} alt={product.name} className="product-image mb-2" />
                      <h5 className="text-primary">{product.name}</h5>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
          <div className="container my-5" style={{ background: 'linear-gradient(135deg, #79e26fff, #7e8ff5ff, #e97f7fff)',padding:10, borderRadius:15 }}>
          <h2 className="text-center mb-3 text-black fw-bold">Our Clients</h2>
         <Carousel
            responsive={responsive}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={2000}
            arrows={false}
            showDots={false}
            draggable={true}
          >
            {clients.map((client, index) => (
              <div key={index} className="text-center px-3">
                <img
                  src={client.logo}
                  alt={client.name}
                  className="img-fluid"
                  style={{ maxHeight: '80px', objectFit: 'contain' }}
                />
              </div>
            ))}
          </Carousel>
        </div>
        <div className="container my-5 mb-2" style={{ background: 'linear-gradient(135deg, #e97f7fff, #bbb80a, #e97f7fff)',padding:13, borderRadius:12 }}>
          <h2 className="text-center mb-3 text-black fw-bold">Certificates</h2>
          <Carousel
            responsive={responsive}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={2000}
            arrows={false}
            showDots={false}
            draggable={true}
          >
            {certificates.map((certificates, index) => (
              <div key={index} className="text-center px-1">
                <img
                  src={certificates.logo}
                  alt={certificates.name}
                  className="img-fluid"
                  style={{ maxHeight: '80px', objectFit: 'contain', marginLeft:400 }}
                />
              </div>
            ))}
          </Carousel>
        </div>
        <div className="container my-5" style={{ background: 'linear-gradient(135deg, #f5e2e2ff, #f8f7cfff, #f5ccccff)' , padding:12,borderRadius:15 }}>
          <h2 className="text-center mb-3 text-black fw-bold">Why Choose RP Smart Solar?</h2>
          <Carousel
            responsive={responsive}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={2000}
            arrows={false}
            showDots={false}
            draggable={true} 
            swipeable={true}
          >
            {general.map((item, index) => (
              <div key={index} className="text-center px-3" >
                <img
                  src={item.logo}
                  alt={item.name}
                  className="img-fluid"
                  style={{ maxHeight: '80px', objectFit: 'contain' }}
                />
                <div className="mt-2">
                  <small className="text-muted">{item.caption}</small>
                </div>
              </div>
            ))}
          </Carousel>
        </div>
        <div className="text-center" role="alert" style={{ fontSize: '1rem', color:'black' }}>
            <b>*Terms and conditions Apply</b>
        </div>
        </div>
      </div>
    </>
  );
};

export default Home;
